import $ from 'jquery';

export default () => {
  const $document = $(document);
  const $body = $document.find('body');
  const callers = $('.popup-caller');
  const popups = $('.popup');
  const overlay = () => $('<div>').attr('id', 'overlay');

  function handler(e) {
    const { caller, popup } = e.data;

    e.stopPropagation();

    // if current caller doesn't selected
    // others might be, so let's clear them
    if (!caller.hasClass('selected')) {
      closeAll();
    }

    caller.toggleClass('selected');
    popup.toggleClass('opened');
    $document.trigger('popup.opened', [popup]);
    $body.toggleClass('popup-opened');

    if (popup.hasClass('with-overlay')) {
      const ol = overlay();

      popup.before( ol );
      ol.fadeIn(250);
      $body.addClass('clip');
    }
  }

  function closeAll() {
    callers.removeClass('selected');
    popups.removeClass('opened full');
    popups.prev('#overlay').remove();
    $body.removeClass('clip').removeClass('popup-opened');
  }

  callers.each(function() {
    const caller = $(this);
    const popupSelector = caller.data('popup');
    let popup;

    if (popupSelector) {
      popup = $(popupSelector);
    } else {
      popup = caller.parent().find('.popup');
    }

    if (popup.length) {
      caller.click({caller, popup}, handler);
    }
  });

  popups.each(function() {
    const popup = $(this);
    const close = popup.find('.close');
    const full = popup.find('.popup-switch-full');

    close.click(closeAll);

    full.click(() => full.closest('.popup').addClass('full'));
  });

  $body.click((e) => {
    // Check if click on document is not associated with popup window,
    // if not close active popup and unselect caller
    if (!$(e.target).closest(popups).length) {
      closeAll();
    }
  });
}
